// Off-click closes secondary menu
jQuery('.cd-secondary-nav').click(function(e) {
  e.stopPropagation();
});


// Search Bar Animation
function searchAnimation() {
  var valux = jQuery('.sb-search-input').val();
  valux = jQuery.trim(valux).length;
  if(valux !== 0) {
    jQuery('.sb-search-submit').css('z-index','99');
  } else{
    jQuery('.sb-search-input').val('');
    jQuery('.sb-search-submit').css('z-index','-999');
  }
}


jQuery(document).ready(function() {
  var submitIcon = jQuery('.sb-icon-search');
  var submitInput = jQuery('.sb-search-input');
  var searchBox = jQuery('.sb-search');
  var isOpen = false;

  jQuery(document).mouseup(function() {
    if(isOpen == true) {
      submitInput.val('');
      jQuery('.sb-search-submit').css('z-index','-999');
      submitIcon.click();
    }
  });

  submitIcon.mouseup(function() {
    return false;
  });

  searchBox.mouseup(function() {
    return false;
  });

  submitIcon.click(function() {
    if(isOpen == false) {
      searchBox.addClass('sb-search-open');
      isOpen = true;
    } else {
      searchBox.removeClass('sb-search-open');
      isOpen = false;
    }
  });

  //JS for the dropdown form located at /general/contact/contact-phonekeypersonnel
  var dropDownValue = document.getElementById("phone-key-personnel");
  if (dropDownValue) {
      dropDownValue.onchange = function() {
          if (this.selectedIndex !== 0) {
              window.location.href = this.value;
          }
      };
  }

});

jQuery('.cd-primary-nav').click(function(e){
    e.stopPropagation();
});

// //Menu Arrow Toggle for Mobile View
// jQuery('.cd-primary-nav li').on('click', function() {
//     if(jQuery(this).parent().parent().hasClass('nav-is-open').find('svg').hasClass('fa-chevron-down')) {
//        jQuery(this).find('svg').addClass('fa-chevron-left');
//        jQuery(this).find('svg').removeClass('fa-chevron-down');
//    }
//    else {
//        jQuery(this).find('svg').addClass('fa-chevron-down');
//        jQuery(this).find('svg').removeClass('fa-chevron-left');
//    }
// });

// Footer Navigation Accordion Close on Click
jQuery(document).ready(function () {
  jQuery('.collapse').collapse;
});

// Removes input styling from inline

function remove_input_form_style(list) {
  'use strict';

  var attr = [
    'align',
    'background',
    'bgcolor',
    'border',
    'cellpadding',
    'cellspacing',
    'color',
    'face',
    'height',
    'hspace',
    'marginheight',
    'marginwidth',
    'noshade',
    'nowrap',
    'size',
    'valign',
    'vspace',
    'width',
    'vlink',
    'alink',
    'text',
    'link',
    'frame',
    'frameborder',
    'clear',
    'scrolling',
    'style'
  ];

  var attr_len = attr.length;
  var i = list.length;

  var j;
  var is_hidden;

  while (i--) {
    is_hidden = list[i].style.display === 'none';

    j = attr_len;

    while (j--) {
      list[i].removeAttribute(attr[j]);
    }

    if (is_hidden) {
      list[i].style.display = 'none';
    }
  }
  var set = document.getElementById('edit-revision-log');
  remove_style(set);
}

// Global Popover
jQuery(document).ready(function() {
  jQuery('[data-toggle="popover"]').popover();
});

// Engage Button Animation
jQuery(document).ready(function() {
  jQuery(".footer-social-button").popover({
    html: true,
    container: '.footer-social-button',
    trigger:'manual',
    content: function () {
      return jQuery('#popoverEngageHiddenContent').html();
    },
    template: '<div class="popover" role="tooltip"><div class="popover-content"></div></div>'
  });
});

jQuery(document).click(function (event) {

  if (!jQuery(event.target).closest('.footer-social-button').length) {
    jQuery('.footer-social-button').popover('hide');
  }
});

// Share Button Window Pop-ups
function tweetCurrentPage() {
  var docTitle = document.title;
  var pipeReplace = docTitle.replace(/[|\w\s]/gi, '');
  window.open("https://twitter.com/intent/tweet?url=" + escape(window.location.href) + "&t=" + pipeReplace, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
  void(0);
}

function fbShareCurrentPage() {
  window.open("https://www.facebook.com/sharer/sharer.php?u=" + escape(window.location.href) + "&t=" + document.title, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
  void(0);
}

function linkCurrentPage() {
  var docTitle = document.title;
  var pipeReplace = docTitle.replace(/[|\w\s]/gi, '');
  window.open("https://www.linkedin.com/shareArticle?mini=true&url=" + escape(window.location.href) + "&t=" + pipeReplace, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
  void(0);
}

// Share Button Animation
jQuery(document).ready(function() {
  jQuery("#btn-share").popover({
    html: true,
    container: '#btn-share',
    trigger:'manual',
    content: function () {
      return jQuery('#popoverShareHiddenContent').html();
    },
    template: '<div class="popover" role="tooltip"><div class="popover-content"></div></div>'
  });
});

// jQuery(document).click(function (event) {
//
//   if (!jQuery(event.target).closest('#btn-share').length) {
//     jQuery('#btn-share').popover('hide');
//   }
// });

// jQuery("a.twitter").attr("href", "https://twitter.com/usdol" + window.location.href);
// jQuery("a.facebook").attr("href", "https://www.facebook.com/departmentoflabor" + window.location.href);
// jQuery("a.instagram").attr("href", "https://www.instagram.com/USDOL/" + window.location.href);
// jQuery("a.rss").attr("href", "https://www.dol.gov/rss" + window.location.href);
// jQuery("a.email").attr("href", "https://public.govdelivery.com/accounts/USDOL/subscriber/new" + window.location.href);

var checkMobile = function () {
    // dPosition = getCoords(ele_h3).top - sPosition;
    if (window.innerWidth < 500 && dPosition != undefined) {
        document.querySelector('.carousel-control-prev').setAttribute('style', "top:" + dPosition + "px");
        document.querySelector('.carousel-control-next').setAttribute('style', "top:" + dPosition + "px");
    }
};

// Carousel Pauses when window size is less than 379px
jQuery(function() {
  checkMobile();
  /* Initialize Carousel */
  var paused = 0;
  if (jQuery(window).width() > 379) {
    jQuery('.carousel').carousel({
      interval: 7000,
      pause: false
    });
  } else {
    jQuery('.carousel').carousel({
      pause: true,
      interval: 0
    });
    checkMobile();
  }

  /* Play trigger */
  jQuery('#pauseButton').click(function() {
    var state = paused ? 'cycle' : 'pause';
    paused = paused ? 0 : 1;
    jQuery('.carousel').carousel(state);
    jQuery(this)
      .find('i')
      .toggleClass('fa-play fa-pause');

    // Compare pause states
    if (paused == 0) {
      jQuery('#pauseButton span').html('Pause');
    } else {
      jQuery('#pauseButton span').html('Play');
    }
  });
});

// Close button and label on mobile subnavigation
jQuery(function() {
  if(jQuery(window).width() <= 768) {
    jQuery('li.sub-menu-close').click(function () {
        jQuery('.dol-subnav-wrapper').toggleClass('sidebar-is-closed');
        jQuery('.dol-subnav-wrapper').toggleClass('sidebar-is-open');
        jQuery('#page-title-area').toggleClass('sidebar-is-closed');
        jQuery('#page-title-area').toggleClass('sidebar-is-open');
        jQuery('.layout-content').toggleClass('sidebar-is-closed');
        jQuery('.layout-content').toggleClass('sidebar-is-open');
    });

    jQuery('.dol-subnav-wrapper label').click(function () {
      jQuery('.dol-subnav-wrapper').toggleClass('sidebar-is-closed');
      jQuery('.dol-subnav-wrapper').toggleClass('sidebar-is-open');
      jQuery('#page-title-area').toggleClass('sidebar-is-open');
      jQuery('.layout-content').toggleClass('sidebar-is-open');
    });
    jQuery('#no-sub-menu').removeClass('sub-nav');
  }
});

// Shows full subnavigation over 768px window width
jQuery(function() {
  if(jQuery(window).width() >= 768) {
    jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-closed');
    jQuery('.dol-subnav-wrapper').addClass('sidebar-is-open');

  }
  else {
    jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-open');
    jQuery('.dol-subnav-wrapper').addClass('sidebar-is-closed');
  }
});

jQuery(window).on('resize', function(){
    if(jQuery(window).width() >= 767) {
        jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-closed');
        jQuery('.dol-subnav-wrapper').addClass('sidebar-is-open');
        jQuery('#page-title-area').removeClass('sidebar-is-open');
        jQuery('.layout-content').removeClass('sidebar-is-open');

    }
    else {
        jQuery('.dol-subnav-wrapper').removeClass('sidebar-is-open');
        jQuery('.dol-subnav-wrapper').addClass('sidebar-is-closed');
        jQuery('#page-title-area').removeClass('sidebar-is-open');
        jQuery('.layout-content').removeClass('sidebar-is-open');
    }
});

jQuery('.dol-sidebar').click(function(event) {
  event.stopPropagation();
});

// Slide counter for Image Gallery
var totalItems = jQuery('.item').length;
var currentIndex = jQuery('div.active').index() + 1;
jQuery('.num').html(''+currentIndex+'/'+totalItems+'');

jQuery('.image-gallery').on('slid.bs.carousel', function() {
  currentIndex = jQuery('div.active').index() + 1;
  jQuery('.num').html(''+currentIndex+'/'+totalItems+'');
});

// Assigns active class to current page's link in subnavigation
jQuery(document).ready(function() {
    var pathname = window.location.pathname;
    jQuery('ul.dol-subnav li a[href="'+pathname+'"]').addClass('current-active-item');
});

// Mobile Get position of h3 and move prev/next icons

var ele_h3 = document.querySelector('main .carousel-item.active h3');
var ele_span = document.querySelector('main .direction-nav span');
function getCoords(elem) {
  // crossbrowser version
  if (elem != null) {
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
  } else {
    return false;
  }
}
var sPosition = getCoords(ele_span).top;
var dPosition = getCoords(ele_h3).top - sPosition;

var checkMobile = function () {
  // dPosition = getCoords(ele_h3).top - sPosition;
  if (window.innerWidth < 500 && dPosition != undefined) {
    document.querySelector('.carousel-control-prev').setAttribute('style', "top:" + dPosition + "px");
    document.querySelector('.carousel-control-next').setAttribute('style', "top:" + dPosition + "px");
  }
};

jQuery('#dolFrontPageCarousel').on('slide.bs.carousel', function () {
  checkMobile();
});

jQuery('#dolFrontPageCarousel').on('slid.bs.carousel', function () {
  checkMobile();
});

(function ($) {
    Drupal.behaviors.myBehavior = {
        attach: function (context, settings)
        {
            $( document ).ready(function() {
              if($(".notoolbar-buttons").length) {
                  $("#top-agency-name .search").addClass("push-right");
              }

            });
        }
    };
})(jQuery);

// Adds bootstrap class for sidebar
jQuery(document).ready(function () {
  if (jQuery('.cd-main-content').find('.dol-subnav-wrapper').length > 0) {
      jQuery('.cd-main-content').addClass('active-book-page');
      // jQuery('.left-sidebar').addClass('col-md-3');
  }
  if (jQuery('.cd-main-content').find('.groups-sidebar').length > 0) {
      jQuery('.cd-main-content').addClass('groups-sidebar');
      // jQuery('.left-sidebar').addClass('col-md-3');
  }
});

// Removes empty space from table cells
jQuery('td').each(function(){
    jQuery(this).html(jQuery(this).html().replace(/&nbsp;/gi,''));
});

// Giving newsletter images an inline style for email styling purposes
jQuery('#newsletter-content img').css({'max-width':'100%'});


// Make Tables Responsive

//exclude on Newsletter Page
var newsletterPage = jQuery( ".newsletter-table" ).length;
jQuery('table').each(function() {
  var responsive = jQuery(this).hasClass('table');
  if (responsive == false && newsletterPage == 0) {
    jQuery(this).addClass('table').wrap('<div class="table-responsive"></div>');
  }
});

// This is needed for the federal holidays modal to work
jQuery('#holidaysModal').appendTo("body");

// This will allow the ilab dropdown to always have the current country selected
(function ($) {
    var currentCountry = $("h3.ilab-country-title").text().trim();
    var selectedCountry = $('.ilab-countries-dropdown select option').filter(function () {
        return $(this).text() == currentCountry;
    }).val();
    $('.ilab-countries-dropdown select').val(selectedCountry);

    // Doing the same for the ilab country pages
    var currentLandingCountry = $('span#country-landing-name').text().trim();
    var selectedLandingCountry = $('.ilab-countries-dropdown select option').filter(function () {
        return $(this).text() == currentLandingCountry;
    }).val();
    $('.ilab-countries-dropdown select').val(selectedLandingCountry);
})(jQuery);

// Adds scroll animation to scroll to top
jQuery(document).ready(function () {
    jQuery(".footer-scroll-to-top").hide();
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 700) {
            jQuery('.footer-scroll-to-top').fadeIn('slow');
        }
        else {
            jQuery('.footer-scroll-to-top').fadeOut('slow');
        }
    });
    jQuery(".footer-scroll-to-top").on('click', function () {
        jQuery("html, body").animate({scrollTop: 0}, 400);
    });
});

jQuery(document).ready(function () {
    if (jQuery('.cd-main-content').find('.agency-homepage').length) {
        jQuery('.pre-content').addClass("homepage");
    }
});

// Enforces DatePicker in ILAB Index Pages using jQuery
jQuery(document).ready(function () {
    jQuery('#ilab_active_on_date').datepicker();
    jQuery('#ilab_active_to_date').datepicker();
    jQuery('#ilab_active_from_date').datepicker();
});
